import React from 'react';

function AIBuilderMessage({ role, kind, content }) {
  const isUser = role === 'user';

  let variantClass = isUser ? 'ai-bubble-user' : 'ai-bubble-assistant';
  if (!isUser && kind === 'needs_input') variantClass = 'ai-bubble-needs-input';
  if (!isUser && kind === 'refusal') variantClass = 'ai-bubble-refusal';
  if (!isUser && kind === 'error') variantClass = 'ai-bubble-error';

  return (
    <div className={`ai-bubble-row ${isUser ? 'ai-bubble-row-user' : 'ai-bubble-row-assistant'}`}>
      <div className={`ai-bubble ${variantClass}`}>
        {content}
      </div>
    </div>
  );
}

export default AIBuilderMessage;
